// Promise.allSettled Polyfill (ES2020)
if (typeof (Promise === null || Promise === void 0 ? void 0 : Promise['allSettled']) !== 'function') {
    Promise['allSettled'] = function (promises) {
        return Promise.all(promises.map(promise => Promise.resolve(promise)
            .then(value => ({
            status: 'fulfilled',
            value,
        }))
            .catch(reason => ({
            status: 'rejected',
            reason,
        }))));
    };
}
